export const routePathToName = (path: string): string => {
  const name = path
    .replace(/^\//, '')
    .replace(/\//g, '-')
  return name || 'root'
}

export const sanitizeRoute = (path: string): string => path.replace(/\/+/g, '/')

export const getArrayParam = (params: Record<string, any>, name: string) => {
  const value = params[name]
  if(!value) return []
  if(Array.isArray(value)) return value
  return [value]
}

export default {
  routePathToName,
  sanitizeRoute,
  getArrayParam,
}
